class Visual {
	constructor(config) {
		this.config = Object.assign({
			scope: '.section-type-visual'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		let $siblings = this.$scope.siblings();

		if($siblings.length > 0) {
			// this.addAnchor($siblings);
		} else {
			this.removeScrollIcon();
		}
	}

	addAnchor($siblings) {
		let $next = $siblings.first();
		let $div = $('<div></div>');
		$div.attr('id', 'scrollTarget');
		$div.append($next);
		this.$scope.after($div);
		this.$scope.find('.scroll-button a').attr('href', '#scrollTarget');
	}

	removeScrollIcon() {
		this.$scope.find('.scroll-button a').remove();
	}
}

export default new Visual;